/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationGroupResponse
 */
export interface OrganisationGroupResponse {
    /**
     *
     * @type {string}
     * @memberof OrganisationGroupResponse
     */
    organisationGroupId?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationGroupResponse
     */
    fullName?: string;
    /**
     * The organisation ids in this group (separated to avoid circular references).
     * @type {Array<string>}
     * @memberof OrganisationGroupResponse
     */
    organisationIds?: Array<string>;
}

/**
 * Check if a given object implements the OrganisationGroupResponse interface.
 */
export function instanceOfOrganisationGroupResponse(
    value: object,
): value is OrganisationGroupResponse {
    return true;
}

export function OrganisationGroupResponseFromJSON(
    json: any,
): OrganisationGroupResponse {
    return OrganisationGroupResponseFromJSONTyped(json, false);
}

export function OrganisationGroupResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        organisationGroupId:
            json["organisationGroupId"] == null
                ? undefined
                : json["organisationGroupId"],
        fullName: json["fullName"] == null ? undefined : json["fullName"],
        organisationIds:
            json["organisationIds"] == null
                ? undefined
                : json["organisationIds"],
    };
}

export function OrganisationGroupResponseToJSON(
    value?: OrganisationGroupResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationGroupId: value["organisationGroupId"],
        fullName: value["fullName"],
        organisationIds: value["organisationIds"],
    };
}
